import React from 'react';
import CardMain from '$/components/Interactions/cards/CardMain';
import { CardContext, CardContextState } from '$/components/Interactions/cards/CardContext';
import { withContextValue } from '$/hooks/withPartialContexts';
import { InteractionInfo } from '../InteractionInfo';

const SpecialOfferCard: React.FC = withContextValue<
  CardContextState,
  { interaction: InteractionInfo },
  { interaction: InteractionInfo }
>(CardContext, ({ interaction }) => ({ interaction }))(({ interaction }) => {
  if (!interaction.details) return null;

  return <CardMain.ExpiresButton interaction={interaction} />;
});

export default SpecialOfferCard;
